import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-military-readiness',
  imports: [PillarPagesTemp],
  templateUrl: './military-readiness.html',
  styleUrl: './military-readiness.scss',
})
export class MilitaryReadiness {

}
